<template>
  <div id="app" ref="app">
    <router-view></router-view>
    <BackTop />
  </div>
</template>

<script>
import Home from '@/views/Home'
import { setI18nLanguage } from '@/i18n'

export default {
  name: 'App',
  components: {
    Home,
  },
  created() {
    // 从localStorage获取语言设置，如果没有则默认使用中文
    const language = localStorage.getItem('language') || 'zh';
    setI18nLanguage(language);
  },
  watch: {
    $route() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
@import url('./assets/css/icon.css');
</style>
